import axios from 'axios'

// Set axios defaults
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
axios.defaults.timeout = 1 * 61 * 1000 // 1 min 1 sec. I've made this 1 sec longer than the requestTimeouts in the API, so we get the API error message rather than the Axios error.